/* /assets/custom-video-carousel.js */
(function () {
  function bindVideoInteractions(container) {
    if (container.dataset.videoBound === 'true') return;
    container.dataset.videoBound = 'true';

    var section = getSection(container);
    // When fullscreen is enabled the section renders a modal in the DOM; play
    // should open that large modal. When it's disabled there is no modal, so we
    // fall back to plain inline playback.
    var hasModal = !!(section && section.querySelector('[data-video-modal]'));

    var slides = container.querySelectorAll('[data-video-slide]');

    slides.forEach(function (slide) {
      var video = slide.querySelector('[data-video]');
      var playBtn = slide.querySelector('[data-video-play]');
      var expandBtn = slide.querySelector('[data-video-expand]');
      if (!video) return;

      // Defensive: ensure native controls stay off even if other theme code or
      // browser defaults try to enable them.
      video.controls = false;
      video.removeAttribute('controls');
      try { video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback'); } catch (e) {}
      try { video.disablePictureInPicture = true; } catch (e) {}

      // Pressing play (or tapping the slide) opens the large modal so the video
      // plays big. Falls back to inline playback when there's no modal.
      function activate(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (hasModal) {
          openModal(section, video);
        } else {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
      }

      if (playBtn) {
        playBtn.addEventListener('click', activate);
      }

      slide.addEventListener('click', function (e) {
        if (playBtn && (e.target === playBtn || playBtn.contains(e.target))) return;
        // The expand button has its own handler (bindExpandButtons).
        if (expandBtn && (e.target === expandBtn || expandBtn.contains(e.target))) return;
        activate(e);
      });

      // Inline-playback state class (only relevant in the no-modal fallback).
      video.addEventListener('play', function () {
        slide.classList.add('is-playing');
      });
      var onStopClass = function () {
        slide.classList.remove('is-playing');
      };
      video.addEventListener('pause', onStopClass);
      video.addEventListener('ended', onStopClass);
    });
  }

  function bindFlickityAutoplayPause(container) {
    if (container.dataset.flickityBound === 'true') return;
    if (!container.matches('[data-carousel]')) return;

    var flkty = window.Flickity && Flickity.data(container);
    if (!flkty) {
      // Retry up to ~3 seconds while the <flickity-carousel> custom element
      // initializes Flickity asynchronously.
      var attempts = parseInt(container.dataset.flickityAttempts || '0', 10);
      if (attempts < 30) {
        container.dataset.flickityAttempts = String(attempts + 1);
        setTimeout(function () { bindFlickityAutoplayPause(container); }, 100);
      }
      return;
    }

    container.dataset.flickityBound = 'true';

    var videos = container.querySelectorAll('video');
    var playingCount = 0;

    function onPlay() {
      playingCount++;
      flkty.pausePlayer();
    }

    function onStop() {
      playingCount = Math.max(0, playingCount - 1);
      if (playingCount === 0) {
        flkty.unpausePlayer();
      }
    }

    videos.forEach(function (v) {
      v.addEventListener('play', onPlay);
      v.addEventListener('pause', onStop);
      v.addEventListener('ended', onStop);
    });

    flkty.on('change', function () {
      videos.forEach(function (v) {
        if (!v.paused) {
          v.pause();
        }
      });
    });
  }

  function getSection(container) {
    return container.closest('.section-video-carousel');
  }

  // Returns the Flickity instance for the section's carousel, if any.
  function getCarouselFlkty(section) {
    if (!section || !window.Flickity) return null;
    var carousel = section.querySelector('[data-carousel]');
    return carousel ? Flickity.data(carousel) : null;
  }

  function closeModal(section) {
    if (!section) return;
    var modal = section.querySelector('[data-video-modal]');
    if (!modal || modal.hidden) return;
    var inner = modal.querySelector('[data-video-modal-inner]');
    if (inner) inner.innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('video-carousel-modal-open');
    // Resume carousel autoplay that was paused while the modal was open.
    var flkty = getCarouselFlkty(section);
    if (flkty) flkty.unpausePlayer();
  }

  function openModal(section, videoEl) {
    if (!section || !videoEl) return;
    var modal = section.querySelector('[data-video-modal]');
    var inner = modal && modal.querySelector('[data-video-modal-inner]');
    if (!modal || !inner) return;

    if (!videoEl.paused) videoEl.pause();

    var clone = videoEl.cloneNode(true);
    clone.controls = true;
    clone.removeAttribute('controlslist');
    clone.disablePictureInPicture = false;
    clone.autoplay = true;
    clone.muted = false;
    clone.removeAttribute('data-video');

    inner.innerHTML = '';
    inner.appendChild(clone);
    modal.hidden = false;
    document.body.classList.add('video-carousel-modal-open');

    // Pause carousel autoplay so it doesn't rotate behind the open modal.
    var flkty = getCarouselFlkty(section);
    if (flkty) flkty.pausePlayer();

    var p = clone.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function bindExpandButtons(container) {
    if (container.dataset.expandBound === 'true') return;
    container.dataset.expandBound = 'true';

    var section = getSection(container);
    if (!section) return;

    container.querySelectorAll('[data-video-expand]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var slide = btn.closest('[data-video-slide]');
        var video = slide && slide.querySelector('[data-video]');
        if (video) openModal(section, video);
      });
    });
  }

  function bindModalClose(section) {
    if (!section || section.dataset.modalCloseBound === 'true') return;
    var modal = section.querySelector('[data-video-modal]');
    if (!modal) return;
    section.dataset.modalCloseBound = 'true';

    var closeBtn = modal.querySelector('[data-video-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeModal(section); });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(section);
    });
  }

  function init(container) {
    if (!container) return;
    bindVideoInteractions(container);
    bindFlickityAutoplayPause(container);
    bindExpandButtons(container);
    var section = getSection(container);
    if (section) bindModalClose(section);
  }

  function bootAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-video-carousel]').forEach(init);
  }

  // Global Escape handler — closes any open video modal on the page.
  if (!window.__videoCarouselEscBound) {
    window.__videoCarouselEscBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.section-video-carousel').forEach(function (section) {
        closeModal(section);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }

  // Re-initialize when the merchant inserts/edits the section in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    bootAll(e.target);
  });
})();
